import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import VueCookie from "vue-cookie";
import router from "../../router";

Vue.use(VueCookie);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    cancelSubscription: ({ state, dispatch }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "cancel_subscription",
          customer_id: router.history.current.query.customer_id,
          order_id: router.history.current.query.order_id,
          email: state.subscription.email,
          firstname: state.subscription.firstname,
          lastname: state.subscription.lastname,
          country_id: state.customerData.country,
          subscription_type_name: state.subscriptionType.name,
          subscription_access_token:
            router.history.current.query.subscription_access_token,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "SUBSCRIPTION NOT FOUND") {
            dispatch("changeErrorMsg", {
              msg: "Could not find subscription",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "SUBSCRIPTION NOT CANCELED") {
            dispatch("changeErrorMsg", {
              msg: "Could not cancel subscription",
              type: "negativ",
            });
            return false;
          }
          if (response.data.error == "") {
            dispatch("changeErrorMsg", {
              msg: "Your subscription was canceled successfully.",
              type: "positiv",
            });
          }
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
    sendInvoice: ({ dispatch }, payload) => {
      return axios({
        cancelToken: getcancelToken(payload),
        method: "post",
        data: {
          action: "send_invoice",
          email: payload.email,
          invoice_id: payload.invoice_id,
          order_id: router.history.current.query.order_id,
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "") {
            dispatch("changeErrorMsg", {
              msg: "Your invoice was sent successfully to " + payload.email,
              type: "positiv",
            });
          }
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
  },
};

function getcancelToken(payload) {
  if (typeof payload != "undefined") {
    if (typeof payload.cancelToken != "undefined") {
      if (typeof payload.cancelToken.token != "undefined") {
        return payload.cancelToken.token;
      }
    }
  }
  return null;
}
